import { Injectable } from "@angular/core";
import { HttpClient } from "@angular/common/http";
import { HttpClientBase } from "./http-client-base.service";

export interface Bucket {
  id: number;
  idServicioExterno: string;
  proveedor: string;
  region: string;
  bucketOContenedor: string;
  credencialesJson: {
    roleArn: string;
  };
  createdAt: string;
  updatedAt: string;
}

interface ApiResponse<T> {
  item: T[];
}
@Injectable({ providedIn: "root" })
export class BucketService extends HttpClientBase {
  // private endpoint = "servicios/externos";

  // private endpoint_register_user = "auth/register";

  constructor(http: HttpClient) {
    super(http, "servicios/externos");
  }

  get headers() {
    return {
      headers: {},
    };
  }

  getBuckets(idServicio, page, limit, search = null, pagination = "true") {
    /* return this.get<any[]>({
      endpoint: `?page=${page}&limit=${limit}&search=${search}&pagination=${pagination}`,
    });*/
    return this.get<Bucket[]>({
      endpoint: `/${idServicio}/storage/config?page=${page}&limit=${limit}&pagination=${pagination}`,
    });
  }
}
